module.exports = __webpack_public_path__ + "img/silent-video.049f648b.svg";